module.exports = __webpack_public_path__ + "img/shop4de.1b6c1f08.png";